<template>
  <div>Can not render content</div>
</template>

<script>
export default {};
</script>